import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { login, logout } from "@admin/redux/slices/auth/index";
import { AuthState } from "@admin/redux/slices/auth/types";
import { User } from "@/types";

const initialState: AuthState = {
  isAuthorized: false,
  user: null,
  login: {
    loading: false,
    error: "",
  },
  logout: {
    loading: false,
    error: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth(state) {
      state.isAuthorized = initialState.isAuthorized;
      state.user = initialState.user;
      state.login = initialState.login;
      state.logout = initialState.logout;
    },
    setAuthStatus(state, action: PayloadAction<boolean>) {
      state.isAuthorized = action.payload;
    },
    setUserInfo(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.login.loading = true;
      state.login.error = "";
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.login.loading = false;
      state.isAuthorized = true;
      state.user = action.payload.user;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.login.loading = false;
      state.login.error = action.payload;
    });
    builder.addCase(logout.pending, (state) => {
      state.logout.loading = true;
      state.logout.error = "";
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.logout.loading = false;
      state.user = null;
      state.isAuthorized = false;
    });
    builder.addCase(logout.rejected, (state, action) => {
      state.logout.loading = false;
      state.logout.error = action.payload;
      // TODO: logout raises 401 error when token is expired - remove below 3 lines when fixed
      state.user = null;
      state.isAuthorized = false;
    });
  },
});

export const { resetAuth, setAuthStatus, setUserInfo } = authSlice.actions;
export default authSlice.reducer;
